/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {

  //PDP SKIO Plan Picker - Update price on plan selection
  //document.dispatchEvent( new CustomEvent("variantChanged", { detail: { variantId: variant.id } }) );
  const observer = new MutationObserver(() => {
    const selected = document.querySelector('.skio-group-container--selected');
    const price = selected?.querySelector('.skio-price > span')?.textContent.trim();
    if (price) {
      document.querySelector('.btn__price').textContent = price;
    }
  });

  const container = document.querySelector('.skio-plan-picker'); 
  if (container) {
    observer.observe(container, { attributes: true, subtree: true, attributeFilter: ['class'] });
  }

  // Smooth scroll for anchor links - data-attribute implementation
  document.querySelectorAll('a[data-image-anchor][href^="#"]').forEach(link => {
    link.addEventListener('click', function(e) {
      const anchor = this.getAttribute('href').substring(1);
      const target = document.querySelector(`[data-anchor-id="${anchor}"]`);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });

    const contentDiv = link.nextElementSibling;
    if (contentDiv) {
      contentDiv.style.cursor = 'pointer';
      contentDiv.addEventListener('click', () => {
        const anchor = link.getAttribute('href').substring(1);
        const target = document.querySelector(`[data-anchor-id="${anchor}"]`);
        if (target) {
          target.scrollIntoView({ behavior: 'smooth' });
        }
      });
    }
  });

  // Popup Modal Implementation - data-attribute implementation
  document.querySelectorAll('a[data-popup-trigger]').forEach(trigger => {
    trigger.addEventListener('click', function(e) {
      e.preventDefault();

      // Find the closest .brick__block__text parent
      const container = this.closest('.brick__block__text');
      if (!container) return;

      // Find the data-popup-content inside this container
      const content = container.querySelector('[data-popup-content]');
      if (!content) return;

      // Clone the content so the original stays in place
      const modalContent = content.cloneNode(true);

      // Create modal wrapper
      const modal = document.createElement('div');
      modal.className = 'custom-modal';
      modal.innerHTML = `
        <div class="custom-modal-overlay"></div>
        <div class="custom-modal-inner">
          <button class="custom-modal-close">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
              <path d="M24 8L8 24M8 8L24 24" stroke="#FAEBE2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
      `;
      modal.querySelector('.custom-modal-inner').appendChild(modalContent);

      // Append modal to body
      document.body.appendChild(modal);

      // Show modal
      modal.classList.add('active');

      // Close modal on overlay or close button click
      modal.querySelector('.custom-modal-overlay').addEventListener('click', () => modal.remove());
      modal.querySelector('.custom-modal-close').addEventListener('click', () => modal.remove());
    });
  });

  // Scroll Content Changer functionality
  class ScrollContentChanger {
    constructor(element) {
      this.element = element;
      this.phases = element.querySelectorAll('.scroll-content__phase');
      this.bgImages = element.querySelectorAll('.scroll-content__bg-image');
      this.spacers = element.querySelectorAll('.scroll-content__spacer');
      this.blockCount = parseInt(element.dataset.blockCount) || this.phases.length;
      this.isActive = false;
      this.currentPhase = 1;
      
      // Ensure section starts completely inactive
      this.element.classList.remove('scroll-content--active');
      
      this.init();
    }
    
    init() {
      // Only initialize on desktop
      if (window.innerWidth <= 749) return;
      
      // Skip if no content blocks
      if (this.blockCount === 0) return;
      
      this.setupIntersectionObserver();
      this.setupScrollListener();
      
      // Reset all phases first, then set initial state
      this.resetAllPhases();
      
      // Check if section is immediately visible and set up accordingly
      const rect = this.element.getBoundingClientRect();
      if (rect.top <= window.innerHeight && rect.bottom >= 0) {
        this.isActive = true;
        this.handleScroll();
      } else {
        this.updateContent(1);
      }
    }
    
    setupIntersectionObserver() {
      const options = {
        root: null,
        rootMargin: '-50px 0px -50px 0px',
        threshold: [0.1, 0.3, 0.5, 0.7]
      };
      
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          const rect = this.element.getBoundingClientRect();
          const viewportHeight = window.innerHeight;
          
          // Allow for more gradual activation/deactivation
          const isInViewport = (
            rect.top < (viewportHeight * 0.9) && 
            rect.bottom > (viewportHeight * 0.1) &&
            entry.intersectionRatio > 0.1
          );
          
          if (entry.isIntersecting && isInViewport) {
            this.isActive = true;
            this.element.classList.add('scroll-content--active');
            this.handleScroll();
          } else {
            // Add a small delay for smoother deactivation
            setTimeout(() => {
              this.isActive = false;
              this.element.classList.remove('scroll-content--active');
            }, 100);
          }
        });
      }, options);
      
      this.observer.observe(this.element);
    }
    
    setupScrollListener() {
      this.throttledScroll = this.throttle(this.handleScroll.bind(this), 10);
      window.addEventListener('scroll', this.throttledScroll);
    }
    
    handleScroll() {
      const rect = this.element.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      
      // Allow for more gradual deactivation
      const isInViewport = (
        rect.top < (windowHeight * 0.9) && 
        rect.bottom > (windowHeight * 0.1)
      );
      
      // Only deactivate if section is completely out of view
      if (!isInViewport && this.isActive) {
        setTimeout(() => {
          this.isActive = false;
          this.element.classList.remove('scroll-content--active');
        }, 200);
        return;
      }
      
      if (!this.isActive) return;
      
      const elementHeight = this.element.offsetHeight;
      const viewportHeight = windowHeight;
      
      // Calculate scroll progress - start when section enters viewport, end when it exits
      const sectionTop = rect.top;
      const sectionBottom = rect.bottom;
      
      // Progress from when section starts entering viewport to when it finishes exiting
      let scrollProgress = 0;
      
      if (sectionTop <= 0 && sectionBottom > viewportHeight) {
        // Section is actively scrolling through viewport
        const scrollDistance = Math.abs(sectionTop);
        const totalScrollDistance = elementHeight - viewportHeight;
        scrollProgress = Math.min(scrollDistance / totalScrollDistance, 1);
      } else if (sectionBottom <= viewportHeight) {
        // Section has completely passed
        scrollProgress = 1;
      }
      
      // Determine which phase should be active
      let phaseIndex = Math.floor(scrollProgress * this.blockCount) + 1;
      phaseIndex = Math.max(1, Math.min(phaseIndex, this.blockCount));
      
      if (phaseIndex !== this.currentPhase) {
        this.updateContent(phaseIndex);
        this.currentPhase = phaseIndex;
      }
    }
    
    resetAllPhases() {
      // Remove active class from all phases and backgrounds
      this.phases.forEach(phase => {
        phase.classList.remove('active');
      });
      
      this.bgImages.forEach(bg => {
        bg.classList.remove('active');
      });
    }
    
    updateContent(phaseIndex) {
      // Update content phases
      this.phases.forEach((phase, index) => {
        if (index + 1 === phaseIndex) {
          phase.classList.add('active');
        } else {
          phase.classList.remove('active');
        }
      });
      
      // Update background images
      this.bgImages.forEach((bg, index) => {
        if (index + 1 === phaseIndex) {
          bg.classList.add('active');
        } else {
          bg.classList.remove('active');
        }
      });
    }
    
    throttle(func, delay) {
      let timeoutId;
      let lastExecTime = 0;
      return function (...args) {
        const currentTime = Date.now();
        
        if (currentTime - lastExecTime > delay) {
          func.apply(this, args);
          lastExecTime = currentTime;
        } else {
          clearTimeout(timeoutId);
          timeoutId = setTimeout(() => {
            func.apply(this, args);
            lastExecTime = Date.now();
          }, delay - (currentTime - lastExecTime));
        }
      };
    }
    
    destroy() {
      if (this.observer) {
        this.observer.disconnect();
      }
      window.removeEventListener('scroll', this.throttledScroll);
    }
  }
  
  // Initialize scroll content changers
  document.addEventListener('DOMContentLoaded', () => {
    const scrollSections = document.querySelectorAll('[data-section-type="scroll-content"]');
    const instances = [];
    
    scrollSections.forEach(section => {
      instances.push(new ScrollContentChanger(section));
    });
    
    // Reinitialize on resize if needed
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        // Destroy and recreate instances on significant resize
        instances.forEach(instance => instance.destroy());
        instances.length = 0;
        
        scrollSections.forEach(section => {
          instances.push(new ScrollContentChanger(section));
        });
      }, 250);
    });
  });

  // multicolumn readmore/readless
  document.addEventListener('DOMContentLoaded', function () {
    const sections = document.querySelectorAll('.enable_readmore');

    sections.forEach(section => {
      const items = section.querySelectorAll('.grid-item .column__text');

      items.forEach(textBlock => {
        const fullText = textBlock.innerHTML.trim();

        // Skip if already processed or too short
        if (textBlock.dataset.processed || fullText.length < 100) return;

        // Mark as processed
        textBlock.dataset.processed = 'true';

        // Wrap with container
        textBlock.classList.add('readmore-collapsed');

        // Create toggle button
        const button = document.createElement('button');
        button.className = 'readmore-toggle btn btn--text  btn--primary';
        button.textContent = 'Read more';

        // Find the nearest .column__btn
        const btnContainer = textBlock.closest('.grid-item')?.querySelector('.column__btn');

        if (btnContainer) {
          // Insert button inside .column__btn
          btnContainer.appendChild(button);
        } else {
          // Fallback: insert after text if .column__btn is missing
          textBlock.insertAdjacentElement('afterend', button);
        }

        // Toggle logic
        button.addEventListener('click', function () {
          const isCollapsed = textBlock.classList.contains('readmore-collapsed');
          textBlock.classList.toggle('readmore-collapsed');
          button.textContent = isCollapsed ? 'Read less' : 'Read more';
        });
      });
    });
  });

  // dark bg - matic white text
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.enable_readmore').forEach(section => {
      const bgImage = window.getComputedStyle(section).backgroundImage;

      // Proceed only if a background image exists
      if (bgImage !== 'none') {
        const imageUrl = bgImage.slice(5, -2); // Extract URL from `url("...")`

        const img = new Image();
        img.crossOrigin = 'anonymous'; // Avoid CORS issues
        img.src = imageUrl;

        img.onload = function () {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');

          canvas.width = img.width;
          canvas.height = img.height;
          ctx.drawImage(img, 0, 0);

          const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
          let totalLuminance = 0;
          const pixelCount = imageData.data.length / 4;

          for (let i = 0; i < imageData.data.length; i += 4) {
            const r = imageData.data[i];
            const g = imageData.data[i + 1];
            const b = imageData.data[i + 2];
            const luminance = (0.299 * r + 0.587 * g + 0.114 * b);
            totalLuminance += luminance;
          }

          const averageLuminance = totalLuminance / pixelCount;

          if (averageLuminance < 150) {
            section.classList.add('dark-bg');
          } else {
            section.classList.add('light-bg');
          }
        };
      }
    });
  });






})();
